import ControlList from '../../utilities/Control/ControlList'
import { Keys } from './constants'
import { StoragePage } from './types'

export const storagePage: StoragePage = {}

export const controlList = new ControlList(Keys.MAIN, {
    path: '2>/v5.6/apis/inventory_book',
    theads: ['#', 'Producto', 'Descripción', 'Cantidad', 'Costo']
})

controlList.badgeRemove('company_id', false)
